<div class="data-view-container" fxLayout="row">
  <mat-label *ngIf="label" class="label">{{ label }}</mat-label>
  <ng-content></ng-content>
  <mat-label *ngIf="value" class="value">{{ value }}</mat-label>
</div>
